// src/components/MenuButton.js
import React from 'react';
import './MenuButton.css';

export default function MenuButton({ onClick }) {
  return (
    <button className="menu-button" onClick={onClick} aria-label="Open menu">
      <span className="bar" />
      <span className="bar" />
      <span className="bar" />
    </button>
  );
}
